// utils/mixins/sa_id_validation_mixin.js
import { validate_sa_id } from '@/utils/validations/luhn_algorithm';

export default {
  methods: {
    validate_sa_id_field(field, value) {
      if (!field.required && (!value || value === '')) return { valid: true, error: null, details: null };

      const validation = validate_sa_id(value);
      return validation.valid
        ? { valid: true, error: null, details: validation }
        : {
            valid: false,
            error: validation.errors[0] || 'Invalid SA ID number',
            details: validation
          };
    },

    format_sa_id_display(id_number) {
      if (!id_number || id_number.length !== 13) return id_number;
      return `${id_number.slice(0, 6)} ${id_number.slice(6, 10)} ${id_number.slice(10, 13)}`;
    }
  }
};
